import { Button } from 'antd/lib'
import ModalComp from 'Components/common/Modal/Modal'

export type EndExamModalPropsType = {
    getVisibility: () => boolean
    content: string
    onCancel?: () => void
    onConfirm: () => void
    closable?: boolean
}

export const EndExamModal: React.FC<EndExamModalPropsType> = (props: EndExamModalPropsType) => {
    return (
        <div data-testid="action-modal-wrapper">
            <ModalComp
                width="400px"
                visible={props.getVisibility()}
                modalFooter={
                    <div className={'modal-button'}>
                        <Button onClick={props.onCancel}>Resume</Button>
                        <Button type="primary" onClick={props.onConfirm}>
                            End Exam
                        </Button>
                    </div>
                }
                onCancel={props.onCancel}
                closable={props.closable}
            >
                <div>
                    <span>{props.content}</span>
                </div>
            </ModalComp>
        </div>
    )
}
